import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent implements OnInit {

  openedMenu:String = '';

  constructor() { }

  ngOnInit(): void {

  }

  openMenu(name:String){

    if(this.openedMenu == name){
      this.openedMenu = '';
    }else{
      this.openedMenu = name;
    }
  }

}
